import {Capacitor} from "@capacitor/core";
import {PushNotifications} from "@capacitor/push-notifications";
import {nativeReadTarget, prepareReadCleanup} from "./nativeBadgeModel";

let accountGeneration = 0;
export function prepareNativeNotificationRead(path, method = "GET") {
  if (Capacitor.getPlatform() !== "android") return () => {};
  const generation = accountGeneration;
  return prepareReadCleanup({
    snapshot: async () => (await PushNotifications.getDeliveredNotifications()).notifications || [],
    remove: notifications => PushNotifications.removeDeliveredNotifications({notifications}),
    isCurrent: () => generation === accountGeneration,
  }, nativeReadTarget(path, method));
}

export async function clearNativeNotificationBadges() {
  accountGeneration += 1;
  if (Capacitor.getPlatform() !== "android") return;
  try { await PushNotifications.removeAllDeliveredNotifications(); } catch {}
}
